module.exports = __webpack_public_path__ + "static/018-173ad6977aa29d6989f523d22f82a0c7.jpg";